<div class="whats-happening-section">
  <div class="whats-happening-section-width">
    <div class="section-header">
      <h2 class="section-title">{{ 'Whats Happening in Seychelles?' | translate }}</h2>
    </div>

    <div class="events-carousel-container" *ngIf="!isLoading && events.length > 0">
      <div class="custom-carousel">
        <button
          class="carousel-arrow carousel-prev"
          (click)="prevSlide()"
          [disabled]="!canGoPrev()"
          aria-label="Previous"
        >
          <span>&lt;</span>
        </button>

        <div class="carousel-track">
          <div class="carousel-slides-wrapper" [style.transform]="getTransformStyle()">
            <div class="carousel-slide" *ngFor="let event of events; let i = index" [ngClass]="getSlideClass(i)">
              <div class="event-item" (click)="navigateToEvent(event.productId)">
                <div class="event-image-wrapper">
                  <span class="eventDate" *ngIf="event.startDate && event.startDate != 'none'">
                    {{ event.startDate | date : 'MMM d' | uppercase }}
                    <sup>{{ event.startRm }}</sup>
                    <span class="ml-1 mr-1">-</span>
                    <span *ngIf="event.endDate != 'none'">
                      {{ event.endDate | date : 'MMM d' | uppercase }}
                      <sup>{{ event.endRm }}</sup>
                    </span>
                  </span>
                  <img
                    [src]="event.productImage"
                    [alt]="event.productName"
                    class="event-image"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div class="event-info">
                  <h3 class="event-title">{{ event.productName }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button class="carousel-arrow carousel-next" (click)="nextSlide()" [disabled]="!canGoNext()" aria-label="Next">
          <span>&gt;</span>
        </button>
      </div>
    </div>

    <div class="view-more-wrapper" *ngIf="!isLoading && events.length > 0">
      <button class="btn btn-primary view-more-btn" (click)="viewAllEvents()">
        {{ 'See more Events going on in the Seychelles' | translate }}
      </button>
    </div>
  </div>
</div>
